import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollLayoutBodyToHash } from '@/utils/tasklistTocScroll';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // Reset overflow-y auto for layout-body for ScrollTop (hash targets scroll separately).
  useEffect(() => {
    if (hash) {
      return scrollLayoutBodyToHash(hash);
    }

    const container = document.querySelector('.layout-body');
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);

  return null;
}
